/* skinfood-pdp.js
   Shared PDP behavior for skin.food products:
   plan toggle, tier selection, bulk stepper, gallery thumbs.
   Per-product state injected by sections/main-product-redesign.liquid as
   window.SkinfoodPDP[productId] = { name, variants, plans }.
   Body carries data-product-id so this file is shared across PDPs.
*/
(function () {
  var root = document.querySelector('[data-skinfood-pdp]');
  if (!root) return;

  var productId = root.getAttribute('data-product-id');
  var state = (window.SkinfoodPDP && window.SkinfoodPDP[productId]) || {};
  var VARIANTS = state.variants || {};
  var PLANS = state.plans || {};
  var NAME = state.name || '';

  var plan = 'one';
  var bulkQty = 4;
  /* Delivery-frequency index into PLANS[tier] (arrays ordered like the
     product's selling-plan group). 0 = default plan. */
  var freqIdx = 0;
  var freqOpts = root.querySelectorAll('[data-plan-freq] .plan-freq__option');

  /* Selling-plan id for a tier at the chosen frequency; falls back to the
     tier's first plan so a product with a single plan still subscribes. */
  function planFor(tierKey) {
    var list = PLANS[tierKey];
    if (!list) return '';
    if (!Array.isArray(list)) return list; /* legacy scalar shape */
    return list[freqIdx] || list[0] || '';
  }

  var tiers = root.querySelectorAll('[data-tiers] .tier');
  var atc = root.querySelector('[data-atc]');
  var planRows = root.querySelectorAll('[data-plan-rows] .plan-row');
  var planPriceEls = root.querySelectorAll('[data-plan-rows] [data-plan-price]');
  var bulkTier = root.querySelector('.tier-bulk');
  var qtyValEl = bulkTier && bulkTier.querySelector('[data-qty-val]');
  var qtyMinusEl = bulkTier && bulkTier.querySelector('.qty-minus');
  var qtyPlusEl = bulkTier && bulkTier.querySelector('.qty-plus');
  var qtyTotalEl = bulkTier && bulkTier.querySelector('[data-qty-total]');
  var qtyTotalStrikeEl = bulkTier && bulkTier.querySelector('[data-qty-total-strike]');

  function activeTier() {
    return root.querySelector('[data-tiers] .tier.is-active') || tiers[0];
  }

  function fmtMoney(n) {
    return (Math.round(n * 100) % 100 === 0) ? '$' + n.toFixed(0) : '$' + n.toFixed(2);
  }

  function renderBulkTotal() {
    if (!bulkTier) return;
    var unitPrice = parseFloat(plan === 'sub'
      ? bulkTier.getAttribute('data-sub-unit-price')
      : bulkTier.getAttribute('data-one-unit-price'));
    var msrp = parseFloat(bulkTier.getAttribute('data-unit-msrp'));
    var min = parseInt(bulkTier.getAttribute('data-min-qty'), 10) || 4;
    if (qtyValEl) qtyValEl.textContent = bulkQty;
    if (qtyTotalEl) qtyTotalEl.textContent = fmtMoney(unitPrice * bulkQty);
    if (qtyTotalStrikeEl) qtyTotalStrikeEl.textContent = fmtMoney(msrp * bulkQty);
    if (qtyMinusEl) qtyMinusEl.disabled = bulkQty <= min;
  }

  function render() {
    var a = activeTier();

    /* Tier sublabel (e.g. "1 month supply") is plan-agnostic — the supply
       count doesn't change between subscribe and one-time. Leave the
       initial server-rendered text alone instead of swapping it. */

    /* Plan rows show the active tier's price for each plan side-by-side.
       Customer sees both sub and one-time prices for whichever pack
       they've selected — picking one updates the ATC button. */
    if (a && planPriceEls.length) {
      var aTierKey = a.getAttribute('data-tier');
      var aSubPrice, aOnePrice;
      if (aTierKey === 'bulk') {
        var aSubUnit = parseFloat(a.getAttribute('data-sub-unit-price'));
        var aOneUnit = parseFloat(a.getAttribute('data-one-unit-price'));
        aSubPrice = fmtMoney(aSubUnit * bulkQty);
        aOnePrice = fmtMoney(aOneUnit * bulkQty);
      } else {
        /* Tier prices are pre-formatted by Liquid via `| money`, so they
           already include the correct currency symbol + locale decimals
           for the visitor's market. Don't prefix `$` or reformat here. */
        aSubPrice = a.getAttribute('data-sub-price') || '';
        aOnePrice = a.getAttribute('data-one-price') || '';
      }
      planPriceEls.forEach(function (el) {
        var which = el.getAttribute('data-plan-price');
        el.textContent = which === 'sub' ? aSubPrice : aOnePrice;
      });
    }

    /* Reflect the active plan in plan-row state (visual selection ring). */
    planRows.forEach(function (row) {
      var isActive = row.getAttribute('data-plan') === plan;
      row.classList.toggle('is-active', isActive);
      var input = row.querySelector('input[type="radio"]');
      if (input) input.checked = isActive;
    });

    if (bulkTier) renderBulkTotal();

    if (!a) return;
    var tierKey = a.getAttribute('data-tier');
    var activeTotal, activeQty;
    if (tierKey === 'bulk') {
      var u = parseFloat(plan === 'sub'
        ? a.getAttribute('data-sub-unit-price')
        : a.getAttribute('data-one-unit-price'));
      activeTotal = u * bulkQty;
      activeQty = bulkQty;
    } else {
      activeTotal = parseFloat(plan === 'sub'
        ? a.getAttribute('data-sub-price')
        : a.getAttribute('data-one-price'));
      /* tier variants (1u/2u/3u) are pre-packed — variant itself represents the pack size, so qty is always 1 */
      activeQty = 1;
    }
    /* CTA label reflects pack size so the customer confirms what they're
       adding. Tier 1 is the implicit baseline so no suffix. Price + plan
       stay in the plan rows above — not duplicated on the button. */
    if (atc) {
      var packPrefix = '';
      if (tierKey === '2') packPrefix = '2-Pack ';
      else if (tierKey === '3') packPrefix = '3-Pack ';
      atc.textContent = 'Add ' + packPrefix + 'to Cart';
    }

    /* Shopify cart permalink — variant + qty from tier, selling plan only if subscribing */
    var vid = VARIANTS[tierKey];
    if (atc && vid) {
      var url = '/cart/' + vid + ':' + activeQty;
      if (plan === 'sub' && planFor(tierKey)) url += '?selling_plan=' + planFor(tierKey);
      atc.href = url;
    }
  }

  /* plan-row selection (replaces the old pill toggle) */
  planRows.forEach(function (row) {
    row.addEventListener('click', function () {
      plan = row.getAttribute('data-plan');
      render();
    });
    /* Native radio change covers keyboard activation (arrow keys / Space). */
    var input = row.querySelector('input[type="radio"]');
    if (input) {
      input.addEventListener('change', function () {
        if (input.checked) {
          plan = row.getAttribute('data-plan');
          render();
        }
      });
    }
  });

  /* Frequency pills: pick a cadence, which also means picking Subscribe. */
  freqOpts.forEach(function (opt, i) {
    var input = opt.querySelector('input[type="radio"]');
    function choose() {
      freqIdx = i;
      freqOpts.forEach(function (o, k) { o.classList.toggle('is-active', k === i); });
      if (input) input.checked = true;
      plan = 'sub';
      render();
    }
    opt.addEventListener('click', function (e) { e.preventDefault(); choose(); });
    if (input) input.addEventListener('change', function () { if (input.checked) choose(); });
  });

  /* ATC — intercept click, POST to /cart/add.js, open Dawn cart drawer.
     Keeps the href as a no-JS fallback (Shopify cart permalink). */
  if (atc) {
    atc.addEventListener('click', function (e) {
      var a = activeTier();
      if (!a) return;
      var tierKey = a.getAttribute('data-tier');
      var vid = VARIANTS[tierKey];
      if (!vid) return; /* nothing to add — let default navigate to /cart */

      e.preventDefault();
      if (atc.getAttribute('aria-disabled') === 'true') return;
      atc.setAttribute('aria-disabled', 'true');
      atc.classList.add('is-loading');

      var qty;
      if (tierKey === 'bulk') qty = bulkQty;
      else qty = 1; /* tier variants are pre-packed — qty is always 1 */

      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      var fd = new FormData();
      fd.append('id', vid);
      fd.append('quantity', qty);
      if (plan === 'sub' && planFor(tierKey)) {
        fd.append('selling_plan', planFor(tierKey));
      }
      if (cart && typeof cart.getSectionsToRender === 'function') {
        fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j }; }); })
        .then(function (res) {
          if (!res.ok || (res.body && res.body.status)) {
            /* Shopify returned an error (sold out, invalid variant, etc) —
               fall back to the permalink so the user still gets feedback. */
            window.location = atc.getAttribute('href') || (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(res.body);
            /* Dawn's cart.js sets is-empty on <cart-drawer> when the last
               line item is removed, but renderContents() never clears it.
               Without this, a delete-then-add flow leaves the drawer styled
               as empty (no padding, header hidden). We just added an item,
               so the cart is definitively non-empty — strip the class. */
            cart.classList.remove('is-empty');
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () {
          window.location = atc.getAttribute('href') || '/cart';
        })
        .finally(function () {
          atc.removeAttribute('aria-disabled');
          atc.classList.remove('is-loading');
        });
    });
  }

  /* tier selection — labels handle mouse click via the native input;
     we also wire `change` so keyboard arrow-key navigation through the
     radio group updates state. Bulk stepper internal clicks are ignored. */
  tiers.forEach(function (t) {
    function activate() {
      if (t.classList.contains('is-unavailable')) return;
      tiers.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      render();
    }
    t.addEventListener('click', function (e) {
      if (e.target.closest('.bulk-qty')) return;
      activate();
    });
    var input = t.querySelector('input[type="radio"][name="pack-size"]');
    if (input) {
      input.addEventListener('change', function () {
        if (input.checked) activate();
      });
    }
  });

  /* bulk stepper */
  if (qtyMinusEl) {
    qtyMinusEl.addEventListener('click', function (e) {
      e.stopPropagation();
      var min = parseInt(bulkTier.getAttribute('data-min-qty'), 10) || 4;
      if (bulkQty > min) { bulkQty--; render(); }
    });
  }
  if (qtyPlusEl) {
    qtyPlusEl.addEventListener('click', function (e) {
      e.stopPropagation();
      bulkQty++;
      render();
    });
  }

  /* gallery thumbs — swap main to image or video depending on the thumb */
  var thumbs = root.querySelectorAll('.gallery-thumb');
  thumbs.forEach(function (th) {
    th.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      th.classList.add('is-active');
      var main = root.querySelector('[data-gallery-main]');
      if (!main) return;
      var videoSrc = th.getAttribute('data-video');
      var poster = th.getAttribute('data-poster') || '';
      if (videoSrc) {
        main.innerHTML = '<video autoplay loop muted playsinline poster="' + poster + '"><source src="' + videoSrc + '" type="video/mp4"></video>';
        return;
      }
      var fullSrc = th.getAttribute('data-full');
      var img = th.querySelector('img');
      var src = fullSrc || (img ? img.src : '');
      var alt = (img && img.alt) || NAME;
      if (src) {
        main.innerHTML = '<img src="' + src + '" alt="' + alt + '">';
      }
    });
  });

  render();
})();
